import {
  type Department,
  type EntityDepartment,
  type EntityLocation,
  type Location,
  ObjectKind,
} from "@digits-graphql/frontend/graphql-bearer"
import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgDataflow04 } from "@digits-shared/components/SVGIcons/line/Dataflow04.svg"
import { SvgMarkerPin02 } from "@digits-shared/components/SVGIcons/line/MarkerPin02.svg"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import type { HierarchicalDimensionNode } from "src/shared/helpers/hierarchicalDimensionHelper"

export const DIMENSION_KINDS = [ObjectKind.Department, ObjectKind.Location] as const

export type DimensionKind = (typeof DIMENSION_KINDS)[number]
export type DimensionEntity = EntityDepartment | EntityLocation
export type DimensionObject = Department | Location
export type DimensionNode = HierarchicalDimensionNode<DimensionObject>

// TODO always green (Assets)? based on kind?
export const DIMENSION_ICON_COLOR = new Map<ObjectKind, string>([
  [ObjectKind.Department, "#2C9D80"],
  [ObjectKind.Location, "#33BDD0"],
])

export const DIMENSION_ICON_KEY = new Map<ObjectKind, string>([
  [ObjectKind.Department, "Dataflow04"],
  [ObjectKind.Location, "MarkerPin02"],
])

const PLURAL_BY_KIND: Record<DimensionKind, string> = {
  [ObjectKind.Department]: "Departments",
  [ObjectKind.Location]: "Locations",
} as const

export const pluralizeDimension = (kind: DimensionKind) => PLURAL_BY_KIND[kind]

export const isDimensionKind = (k: string): k is DimensionKind =>
  (DIMENSION_KINDS as readonly string[]).includes(k)

export const SvgDepartmentIcon = styled(SvgDataflow04)`
  ${svgPathStyles(colors.secondary)}
`

export const SvgLocationIcon = styled(SvgMarkerPin02)`
  &&& g {
    fill: none;
  }

  ${svgPathStyles(colors.secondary)}
`
